export const GENERAL = 'general';
export const ESTIMATES = 'estimates';
export const DMS = 'dms';
export const NOTIFICATIONS = 'notifications';
export const SELLER = 'seller';
export const TIRES = 'tires';
export const MOCK = 'mock';
